import {useFeature} from '@pagaleve/features-lib'
import logoPngOld from '@src/assets/images/logo/logo.png'
import logoSvgOld from '@src/assets/images/logo/logo.svg'
import logoPngNew from '@src/assets/images/logo/logo-full-rebranding.png'
import logoSvgNew from '@src/assets/images/logo-rebranding.svg'

export function useRebrandingActive() {
  return useFeature({fallback: false, name: 'rebrandingActive'})
}

/** Símbolo Pagaleve em SVG (formulários, menu, etc.) */
export function usePagaleveLogoSymbolSvg() {
  const rebrandingActive = useRebrandingActive()
  return rebrandingActive ? logoSvgNew : logoSvgOld
}

/** Logo horizontal em PNG (header, spinner inicial) */
export function usePagaleveLogoHeaderPng() {
  const rebrandingActive = useRebrandingActive()
  return rebrandingActive ? logoPngNew : logoPngOld
}
